import { Injectable } from '@angular/core';
import { ETipoPermiso } from '@core/enums/tipoPermiso.enum';
import { environment } from '@env/environment';
import { BaseHttpService } from '@shared/services/base-http.service';

@Injectable({
  providedIn: 'root',
})
export class PermisoApiService extends BaseHttpService {
  cargarPermisos() {
    return this.withLoader(
      this.httpClient.get<ETipoPermiso[]>(
        `${environment.apiUrl}${environment.apiPreFix}/usuario/cargar-permisos`,
      ),
    );
  }
}
